/* Shared PDP/card transport. The existing header owns cart rendering and opening. */
(() => {
  const pending = new WeakSet();
  const signal = name => document.dispatchEvent(new CustomEvent(name));

  async function add({ form, button, target, variant, beforeAdded, onError, onSuccess }) {
    if (pending.has(button)) return false;
    pending.add(button);
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    signal('theme:loading:start');
    try {
      const response = await fetch(`${window.routes.cartAddUrl}.js`, {
        body: new FormData(form),
        credentials: 'same-origin',
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.description || error.message || 'Não foi possível adicionar o produto.');
      }
      if (beforeAdded) await beforeAdded();
      target.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: { variant, quantity: Number(new FormData(form).get('quantity') || 1) }
      }));
      if (onSuccess) onSuccess();
      return true;
    } catch (error) {
      onError(error.message || 'Não foi possível adicionar. Tente novamente.');
      return false;
    } finally {
      pending.delete(button);
      button.disabled = false;
      button.removeAttribute('aria-busy');
      signal('theme:loading:end');
    }
  }

  window.themeCartAdd = {
    add,
    fromProduct(context, event, button) {
      if (window.theme.cartType === 'page') return;
      event.preventDefault();
      event.stopPropagation();
      return add({
        form: context.element.querySelector('form[action*="/cart/add"]'),
        button, target: context.element, variant: context.currentVariant,
        beforeAdded: () => {
          if (context.options.isQuickView && window.theme.cartType === 'drawer') signal('modal:close');
        },
        onError: message => context._showAlert(message.replace(/[&<>"']/g, character => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character])), 'error', button),
        onSuccess: () => {
          if (window.theme.cartType === 'message') context._showAlert(window.languages.productAdded, 'success', button);
        }
      });
    }
  };
})();
